import { render, staticRenderFns } from "./tab_sources.vue?vue&type=template&id=bd8f28e6&scoped=true&"
import script from "./tab_sources.vue?vue&type=script&lang=js&"
export * from "./tab_sources.vue?vue&type=script&lang=js&"
import style0 from "./tab_sources.vue?vue&type=style&index=0&id=bd8f28e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8f28e6",
  null
  
)

export default component.exports